/**
 * Voice commands that change screens should defer navigation until Ashley
 * finishes speaking the acknowledgement (see AshleyInterfaceProvider).
 *
 * @param {string} message Spoken confirmation.
 * @param {() => void} performAction Navigation or workflow launch.
 * @param {object} [extras]
 */
export function deferredVoiceResult(message, performAction, extras = {}) {
  return {
    success: true,
    message,
    performAction,
    ...extras,
  };
}

/**
 * @param {string} message
 * @param {() => void} performAction
 * @param {string} code
 */
export function deferredVoiceFailure(message, performAction, code) {
  return {
    success: false,
    code,
    message,
    performAction,
  };
}
